// extracted by mini-css-extract-plugin
export default {"errorMessage":"_404_errorMessage__jY5CP","errorBody":"_404_errorBody__+FdAx"};